import { makeObservable, observable } from 'mobx';
import { ISyncModel, SyncModel } from "@common/models/SyncModel";
export interface IIntakePetSectionQuestionListValue extends ISyncModel {
  intakePetSectionQuestionListValueId: number;
  intakePetSectionQuestionId: number;
  name: string;
  sortOrder: number;
  isSelected: boolean;
  storage: string;
}

export class IntakePetSectionQuestionListValue extends SyncModel
  implements IIntakePetSectionQuestionListValue
{
  @observable intakePetSectionQuestionListValueId: number;
  @observable intakePetSectionQuestionId: number;
  @observable name: string;
  @observable sortOrder: number;
  @observable isSelected: boolean;
  @observable storage: string;

  constructor(params: Partial<IIntakePetSectionQuestionListValue> = {}) {
    const {
      intakePetSectionQuestionListValueId = 0,
      intakePetSectionQuestionId = 0,
      name = '',
      sortOrder = 0,
      isSelected = false,
      storage = '',
    } = params;
    super(params);
    this.intakePetSectionQuestionListValueId =
      intakePetSectionQuestionListValueId;
    this.intakePetSectionQuestionId = intakePetSectionQuestionId;
    this.name = name;
    this.sortOrder = sortOrder;
    this.isSelected = isSelected;
    this.storage = storage;

    makeObservable(this);
  }
}
